import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a0f6f5d2ab6ae0014fbd6d8/rijschoolsimson/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a0f6f5d2ab6ae0014fbd6d8/rijschoolsimson/src/components/TarievenContent.tsx");
